import script from "./InvoiceSalesOfferTable.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSalesOfferTable.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSalesOfferTable.vue?vue&type=style&index=0&id=3f3a89fb&lang=css"

const __exports__ = script;

export default __exports__